import apiConfig from '@constants/apiConfig';

import DeviceListPage from './device/DeviceManagement';
import DeviceSavePage from './device/DeviceSavePage';
import DeviceTab from './device/DeviceTab';
import AreaSavePage from './device/DeviceTab/AreaSavePage';
import DeviceChildSavePage from './device/DeviceTab/DeviceChildSavePage';
import GroupDeviceSavePage from './device/DeviceTab/GroupDevice/GroupDeviceSavePage';
import MappingSavePage from './device/DeviceTab/MappingSavePage';
import PrinterMappingListPage from './device/DeviceTab/PrinterMapping/PrinterMappingListPage';
import PrinterMappingSavePage from './device/DeviceTab/PrinterMapping/PrinterMappingSavePage';
export default {
    kitplayDeviceManagement: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management',
        title: 'Device Management',
        auth: true,
        component: DeviceListPage,
    },
    kitplayDeviceSavePage: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/:id',
        title: 'Device Save Page',
        auth: true,
        component: DeviceSavePage,
        separateCheck: true,
        permission: [apiConfig.kitplayDevice.create.baseURL, apiConfig.kitplayDevice.update.baseURL],
    },
    DeviceTab: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/group-device',
        title: 'Device Management',
        auth: true,
        keyActiveTab: 'activeDeviceTab',
        component: DeviceTab,
        permission: [apiConfig.printer.getList.baseURL, apiConfig.printerGroup.getList.baseURL],
    },
    GroupDeviceSavePage: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/group-device/:id',
        title: 'Group Device Save Page',
        auth: true,
        component: GroupDeviceSavePage,
        separateCheck: true,
        permission: [apiConfig.printerGroup.create.baseURL, apiConfig.printerGroup.update.baseURL],
    },
    DeviceChildSavePage: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/device-child/:id',
        title: 'Device Child Save Page',
        auth: true,
        component: DeviceChildSavePage,
        separateCheck: true,
        permission: [apiConfig.printer.create.baseURL, apiConfig.printer.update.baseURL],
    },
    AreaSavePage: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/area/:id',
        title: 'Area Save Page',
        auth: true,
        component: AreaSavePage,
        separateCheck: true,
        permission: [apiConfig.areas.create.baseURL, apiConfig.areas.update.baseURL],
    },
    mappingSavePage: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/:printerId/mapping/:id',
        title: 'Mapping Save Page',
        auth: true,
        component: MappingSavePage,
        permission: [apiConfig.printerMapping.update.baseURL, apiConfig.printerMapping.create.baseURL],
    },
    // printerMapping: {
    //     path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/:printerId/printer-mapping',
    //     title: 'Printer Mapping',
    //     auth: true,
    //     component: PrinterMappingListPage,
    //     permission: [apiConfig.printerMapping.getList.baseURL],
    // },
    printerMappingSavePage: {
        path: '/kitplay-device/kitplay-shop-accounts/:customerId/device-management/:printerId/printer-mapping/:id',
        title: 'Printer Mapping Save Page',
        auth: true,
        component: PrinterMappingSavePage,
        permission: [apiConfig.printerMapping.update.baseURL, apiConfig.printerMapping.create.baseURL],
    },
};
